// 🔑 **TODO.md F-06. The per-view help button.** `shared/_help_button` renders the icon and a `<template>`
// holding the text (`U-91` moved both out of `shared/_page_title`); this moves it into `#mainModal` and
// shows it.
//
// 🚨 **The template is found RELATIVE TO THE BUTTON, never by `getElementById`.** With the offcanvas open
// over the customers index there are TWO `helpModalTemplate` elements in the document, and
// `getElementById` returns the first — so the customer tab's help would have shown the index's text. A
// duplicate id is invalid HTML anyway, hence the class.
// 📌 A `<template>` rather than a fetch (`F-170`'s pattern): the text is known at render time, so a round
// trip would buy nothing and could fail. The markup is built by ERB, not assembled here.
//
// 🚨 **Delegated from `document`, because an enumerated container list could not be complete.** It was
// `#content`, then `#content, #offcanvasRight` after the owner reported the icon doing nothing on a
// customer tab (the offcanvas is a SIBLING of `#content`, not a child), then a third entry for the
// mobile laatu page — which has neither, because `layouts/application.html.erb` yields directly on that
// action. Each entry was added after the button was found dead somewhere, and nothing reports a dead
// one: the markup is right, the locale key exists, every other guard passes.
// 🔑 `document` is the one root that cannot be missed and that Turbolinks never replaces, and the
// namespaced `off()`/`on()` is what keeps it idempotent — `CLAUDE.md` → *Pack Initialisation*. The
// precedent is `packs/application.js`'s own `$(document).on('select2:open', …)`.
import showTemplateInModal from 'src/showTemplateInModal'

export default () => {
  $(document).off('.helpModal')
  $(document).on('click.helpModal', '.help-button', function() {
    // 🔑 **Adjacency, not an ancestor class — `TODO.md` U-95.** This was
    // `closest('.page-title-row').find(…)`, which obliged EVERY caller of `shared/_help_button` to supply
    // that wrapper: documented in three files, and `quality_controls/laatu.html.erb` carried the class
    // purely as a hook for this line.
    // 📌 `shared/_help_button` emits the button and its `<template>` as adjacent siblings, always — one
    // partial, no caller involvement — so `nextAll(…).first()` finds the right one with no requirement on
    // the markup around it. ⚠️ It keeps the per-button relativity that matters: two help templates can be
    // in one document (the customers index with the offcanvas open over it), so this must never become a
    // document-wide `querySelector`.
    const template = $(this).nextAll('.help-modal-template').first()[0]
    if (!showTemplateInModal(template)) { return }

    mainModal.show()
  })
}
